import React from 'react';
import ResultSuccess from './result-success';
import ResultFailure from './result-failure';

import { AUTO_MAPPING_SEARCH_STATUS } from 'constants/auto-mapping';
import useLogic from './MappingResult.logic';
import PropTypes from 'prop-types';

const MappingResult = ({ result }) => {
  const { state } = result ?? {};

  useLogic();

  return state === AUTO_MAPPING_SEARCH_STATUS.SUCCESS ? (
    <ResultSuccess result={result} />
  ) : (
    <ResultFailure />
  );
};

MappingResult.propTypes = {
  result: PropTypes.shape({
    mappingId: PropTypes.string,
    state: PropTypes.string,
    studentName: PropTypes.string,
    studentId: PropTypes.string,
    otherTeachers: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        score: PropTypes.number,
        enrollments: PropTypes.number,
        sopScore: PropTypes.number,
        studentDensity: PropTypes.number,
        plusPacToPaid: PropTypes.number,
        basePacToPaid: PropTypes.number,
      }),
    ),
    bestTeacher: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      score: PropTypes.number,
      enrollments: PropTypes.number,
      sopScore: PropTypes.number,
      studentDensity: PropTypes.number,
      plusPacToPaid: PropTypes.number,
      basePacToPaid: PropTypes.number,
    }),
  }),
};

export default MappingResult;
